import firebase from 'firebase/app';

const hasConsent = () =>
  window.localStorage.getItem("cookie_consent") === "accepted";

const log = (eventName, params) => {
  if (!hasConsent()) return;
  try {
    firebase.analytics().logEvent(eventName, params);
  } catch (e) {
    // analytics may not be initialised yet — safe to swallow
  }
};

export const logPageView = (pagePath) =>
  log('page_view', {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });

export const logLogin = (method = 'email') => log('login', { method });

export const logSignUp = (method = 'email') => log('sign_up', { method });

export const logViewBusiness = (id, name) =>
  log('view_item', { item_id: id, item_name: name, item_category: 'venue' });

export const logSearch = (term) => log('search', { search_term: term });

export const logClaimStarted = (venueId) =>
  log('claim_venue_started', { venue_id: venueId });

export const logClaimCompleted = (venueId) =>
  log('claim_venue_completed', { venue_id: venueId });
